define('RecentlyViewedItems.Collection', [
    'Singleton',
    'SC.Configuration',
    'Item.Collection',
    'Tracker',

    'jQuery',
    'underscore',
    'Utils'
], function RecentlyViewedItemsCollection(
    Singleton,
    Configuration,
    ItemCollection,
    Tracker,
    jQuery,
    _
) {
    var RecentlyViewedItemsModel = ItemCollection.extend(
        {
            // @method initialize
            initialize: function initialize() {
                this.useCookie = Configuration.recentlyViewedItems && Configuration.recentlyViewedItems.useCookie;
                this.searchApiMasterOptions = Configuration.searchApiMasterOptions.Facets;
                this.track_on = false;
                if (this.useCookie) {
                    this.promise = this.loadItemsFromCookie();
                } else {
                    this.promise = jQuery.Deferred().resolveWith(this);
                }
            },
            // @method addHistoryItem
            addHistoryItem: function addHistoryItem(item) {
                var self;
                var currentItems;
                var newsItems;
                if (this.useCookie) {
                    self = this;
                    this.promise.done(function doneAddHist() {
                        // If the item is already in the recently viewed, we remove it
                        self.remove(item);
                        // we add the item at the beginning of a collection
                        self.unshift(item);
                        if (self.useCookie) {
                            currentItems = jQuery.cookie('recentlyViewedIds');
                            newsItems = _.union(self.pluck('internalid'), currentItems);

                            jQuery.cookie('recentlyViewedIds', newsItems, { path: '/' });
                        }
                    });
                }
            },
            // @method loadItemsFromCookie
            loadItemsFromCookie: function loadItemsFromCookie() {
                // create an array of ID items to get only the elements that are present in the cookie but are not present in memory
                var cookieIds = jQuery.cookie('recentlyViewedIds') || [];
                var itemsIds;

                if (typeof cookieIds === 'string') {
                    cookieIds = [cookieIds.replace(/[\[\]]+/g, '')];
                } else if (!_.isArray(cookieIds)) {
                    cookieIds = [cookieIds];
                }
                itemsIds = _.difference(cookieIds, this.pluck('internalid')).join(',');
                if (itemsIds) {
                    return this.fetch({ data: { id: itemsIds } }, { silent: true }).fail(function failFetch(jqXhr) {
                        jqXhr.preventDefault = true;
                    });
                }
                return jQuery.Deferred().resolveWith(this);
            },
            turnOnTracking: function turnOnTracking() {
                this.track_on = true;
            },
            trackCollection: function trackCollection() {
                var self = this;

                this.promise.done(function donepromise() {
                    if (self.track_on) {
                        Tracker.getInstance().trackProductListEvent(self, 'Recently Viewed Items');
                        self.track_on = false;
                    }
                });
            }
        }
    );

    return {
        getInstance: function getInstance() {
            this.instance = this.instance || new RecentlyViewedItemsModel();
            this.instance.trackCollection();
            return this.instance;
        }
    };
});

